//@ts-nocheck
import { InjectionToken } from '@angular/core';

export interface HeapAnalyticsConfig {
	appId: string;
}

export const HEAP_ANALYTICS_CONFIG = new InjectionToken<HeapAnalyticsConfig>('HeapAnalyticsConfig');
